import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { useGET_studentByIdQuery } from 'redux/api/studentsApi'

import PageBody from 'components/atoms/PageBody'
import Tabs from 'components/organisms/tabs/Tabs'

import Referral from 'components/utilized/special/Referral'
import IEP from 'components/utilized/special/IEP'
import IEPIntervention from 'components/utilized/special/IEPIntervention'
import Reevaluation from 'components/utilized/special/Reevaluation'


import { useHash } from 'utils/customHooks/useHash'
import { Box, Button, Typography } from '@mui/material'
import { School } from '@mui/icons-material'



const SpecialStudentPage = () => {
  const { t } = useTranslation()
  const {hash} = useHash();
  const navigate = useNavigate();
  
  const params = useParams()  
  const id = params?.id
  const { data: student } = useGET_studentByIdQuery(id, {skip: !id})

  return ( <> 
      { student && <>

          <Box className="breadcrumbs" sx={{ padding: '5px 20px', marginBottom: '20px', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px', background: '#fff' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <School />
                
                <Typography sx={{ fontSize: '1rem', fontWeight: '600', marginLeft: '10px' }}>{student.first_name} {student.last_name} </Typography>
                
                <Button
                  variant='outlined'
                  color='black'
                  onClick={() => navigate(`/students/edit/${student.id}`)}
                  className='small-button'
                  sx={{ width: '120px', marginLeft: '20px' }}
                >
                  {`${t('common.go-to-profile')}`}
                </Button>

                <Button
                  variant='outlined'
                  color='black'
                  onClick={() => navigate(`/rti-students/${student.id}`)}
                  className='small-button'
                  sx={{ width: '120px', marginLeft: '20px' }}
                >
                  {`${t('common.go-to-rti')}`}
                </Button>
            </div>
          </Box>

          <PageBody>
            
              <Tabs tabKey={hash || 'referral'} colors={['rgba(250,190,88,0.6)','rgba(129,207,224,0.6)','rgba(116,215,165,0.6)','rgba(197,251,139,0.6)']}>
                  <Referral student={student} tabKey="referral" tabText={`1. ${t('special.referral')}`} />
                  <IEP student={student} tabKey="iep" tabText={`2. ${t('special.create-iep')}`} />
                  <IEPIntervention student={student}  tabKey="intervention" tabText={`3. ${t('special.special-education-intervention')}`} />  
                  <Reevaluation student={student} tabKey="reevaluation" tabText={`4. ${t('special.reevaluation')}`} />  
              </Tabs>
         
          </PageBody> 

        </>
      }
    </> 
  )
}
export default SpecialStudentPage